<template>
  <thead>
    <tr>
      <th
        v-for="(column, index) in columns"
        :key="index"
        :style="{ width: column.width, cursor: column.sortable ? 'pointer' : 'default' }"
        @click="setOrder(column)"
      >
        {{ $t(column.displayName) }}
        <i v-if="getSortName(column) === sort.order" :class="`fal fa-fw fa-arrow-${!sort.desc ? 'up' : 'down'}`" />
      </th>

      <th v-if="actions.length > 0" :style="{ width: actionsWidth }" />
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    columns: { type: Array, required: true },
    actions: { type: Array, required: false, default: false },
    actionsWidth: { type: String, required: false, default: '150px' },
    sort: { type: Object, required: false }
  },
  methods: {
    // @vuese
    // Ustawia sortowanie
    setOrder(column) {
      if (column.sortable) {
        const sortName = this.getSortName(column);
        const desc = this.sort.order === sortName ? !this.sort.desc : true;
        this.$emit('order', { order: sortName, desc: typeof desc === 'boolean' ? desc : true });
      }
    },
    // @vuese
    // Sprawdza po jakiej nazwie sortować
    getSortName(column) {
      return column.sortName ? column.sortName : column.name;
    }
  }
};
</script>
